<template>
	<modal-dialog :modal-visible="modalVisible"
		title="Copy from a Quote Template"
		:submit-visible="false"
		v-on:closeModal="$emit('closeModal')">

		<p>Pick a template to copy from</p>

		<table-list record-name="Quote Template"
			:fields="[{label:'Description',key:'quote_description'}]"
			:records="quoteTemplatesLocal"
			:has-edit="true"
			:hide-record-count="true"
			edit-button-text="Select"
			edit-button-icon="fa-copy"
			v-on:edit="selectTemplateRow">
		</table-list>
	</modal-dialog>
</template>

<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"

export default {
	name: "ServiceQuoteTemplatePickerModal",
	components: {
		ModalDialog,
		TableList
	},
	props: ["modalVisible","quoteTemplates"],
	data() {
		return {
			quoteTemplatesLocal: []
		}
	},
	watch: {
		modalVisible(isOpen) {
			if (isOpen && !this.quoteTemplates)
				this.fetchQuoteTemplates()
		},
		quoteTemplates() {
			this.quoteTemplatesLocal = this.quoteTemplates
		}
	},
	methods: {
		fetchQuoteTemplates() {
			let vm = this

			vm.spinner(true)

			vm.getJSON("ServiceQuoteTemplate/get").then(response => {
				vm.spinner(false)

				if (response.success)
					vm.quoteTemplatesLocal = response.data
			})
		},
		selectTemplateRow(templateRow) {
			let vm = this

			let params = {
				include: [
					{model: "ServiceQuoteTemplateObject",include:["Material","EquipmentType","ClassificationGroup"]}
				]
			}

			vm.spinner(true)

			vm.getJSON("ServiceQuoteTemplate/find/"+templateRow.slug,params).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.$emit("templateSelected",response.data)
					vm.$emit('closeModal')
				}
			})
		}
	},
	created() {
		this.quoteTemplatesLocal = this.quoteTemplates
	}
}
</script>
